import logoImage from "@/assets/logo.png";

const Logo = () => {
  return (
    <div className="flex items-center justify-center mb-3 md:mb-5 min-h-[80px] md:min-h-[96px]">
      <img 
        src={logoImage} 
        alt="AILens Logo" 
        className="h-20 md:h-24 w-auto"
        width={200}
        height={96}
        loading="eager"
      />
    </div>
  );
};

export default Logo;
